/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcPortfolioV1TransactionState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_PORTFOLIO_V1_TRANSACTION_STATE_ENTITY_NAME = 'ixc.portfolio.v1.Transaction';
export const ixcPortfolioV1TransactionStateEntity = new schema.Entity<IxcPortfolioV1TransactionState>(IXC_PORTFOLIO_V1_TRANSACTION_STATE_ENTITY_NAME, {}, { idAttribute: (entity: IxcPortfolioV1TransactionState) => `${entity.accountId}-${entity.transactionId}` });

